<h2>Manual Payment</h2>
<mat-divider></mat-divider>
<div class="amount-hold">
  <span class="mt-2"
    >There is an outstanding balance of <b>${{ data.balanceOwing }}</b></span
  >
</div>
<form id="manual-payment-form" class="mm-mt-4">
  <mat-radio-group [formControl]="paymentType" class="mm-mt-4">
    @for (option of paymentTypeOptions; track option) {
    <mat-radio-button
      class="full-width mm-mt-4"
      [disabled]="option.disabled"
      [value]="option.value"
    >
      {{ option.label }} @if (option.disabled) {
      <span>&nbsp;(Currently Unavailable)</span>
      }@if (!option.disabled && option.value === 'manual_payment') {
      <mat-icon
        class="mm-text-primary my-price-info-icon"
        style="cursor: pointer"
        (click)="openStripeChargeDialog()"
        >info</mat-icon
      >
      }
    </mat-radio-button>
    }
  </mat-radio-group>
  @if (paymentType.value === 'manual_payment') {
  <div class="padding-side">
    <mat-radio-group [formControl]="gatewayType" class="mm-mt-4">
      @for (option of gatewayTypeOptions; track option) {
      <mat-radio-button
        class="full-width mm-mt-4"
        [disabled]="option.disabled"
        [value]="option.value"
      >
        {{ option.label }} @if (option.disabled) {
        <span>- Coming Soon</span>
        }
      </mat-radio-button>
      }
    </mat-radio-group>
    @if (gatewayType.value === GatewayType.STRIPE) {
    <div>
      <mat-form-field class="full-width mm-mt-4" appearance="fill">
        <mat-label>Stripe Charge ID</mat-label>
        <input
          [formControl]="charge"
          required
          appearance="fill"
          matInput
          placeholder="e.g. ch_abcdefgh123456"
        />
      </mat-form-field>
      @if (charge.invalid && !charge.pristine) {
      <span class="err-msg">The Charge ID pattern is incorrect. Please check again.</span>
      }
      @if (requireInvoiceId) {
      <mat-form-field class="full-width mm-mt-4" appearance="fill">
        <mat-label>Stripe Invoice ID</mat-label>
        <input
          [formControl]="invoiceId"
          required
          appearance="fill"
          matInput
          placeholder="e.g. in_abcdefgh123456"
        />
      </mat-form-field>
      }
      @if (requireInvoiceId && invoiceId.invalid && !invoiceId.pristine) {
      <span class="err-msg">The Invoice ID pattern is incorrect. Please check again.</span>
      }
    </div>
    } @if (gatewayType.value === GatewayType.LATITUDE) {
    <div>
      <mat-form-field class="full-width mm-mt-4" appearance="fill">
        <mat-label>Latitude Pay Token</mat-label>
        <input
          [formControl]="token"
          required
          appearance="fill"
          matInput
          placeholder="e.g. abcdefgh123456"
        />
      </mat-form-field>
      @if (token.invalid && !token.pristine) {
      <span class="err-msg"
        >The Latitude Pay Token pattern is incorrect. Please check again.</span
      >
      }
    </div>
    } @if (gatewayType.value === GatewayType.ADYEN) {
    <div>
      <mat-form-field class="full-width mm-mt-4" appearance="fill">
        <mat-label>Adyen PSP Reference</mat-label>
        <input
          [formControl]="pspReference"
          required
          appearance="fill"
          matInput
          placeholder="eg: 34532123456"
        />
      </mat-form-field>
      @if (pspReference.invalid && !pspReference.pristine) {
      <span class="err-msg">The PSP Reference pattern is incorrect. Please check again.</span>
      }
    </div>
    }
  </div>
  }
</form>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="mm-bg-accent mm-text-white">Close</button>
  <button
    mat-button
    (click)="confirm()"
    form="maunal-payment-form"
    [disabled]="
      paymentType.value === 'manual_payment' &&
      ((gatewayType.value === GatewayType.STRIPE && (charge.invalid || (requireInvoiceId && invoiceId.invalid))) ||
        (gatewayType.value === GatewayType.LATITUDE && token.invalid) ||
        (gatewayType.value === GatewayType.ADYEN && pspReference.invalid))
    "
    class="mm-bg-primary mm-text-white contains-spinner"
  >
    <span>Confirm</span>
    @if (loading) {
    <mat-spinner class="white-spinner ml-2" diameter="16"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
